export default __webpack_public_path__ + "static/media/next.49505bd2.png";